(() => {
  const node = document.getElementById('bayrak-wholesale-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const approvedForms = new WeakSet();
  let pending = false;
  const isCheckout = value => {
    if (!value) return false;
    const url = new URL(value, location.href);
    return url.origin === location.origin && /\/checkouts?(?:\/|$)/.test(url.pathname);
  };
  const showError = (message, form) => {
    let target = form?.querySelector('[data-bayrak-order-rule]') || document.querySelector('[data-bayrak-order-rule]');
    if (!target) {
      target = document.createElement('p');
      target.className = 'bayrak-order-rule';
      target.dataset.bayrakOrderRule = '';
      target.setAttribute('role', 'alert');
      (form || document.querySelector('main') || document.body).append(target);
    }
    target.textContent = message;
    target.dataset.invalid = '';
    target.tabIndex = -1;
    target.focus({preventScroll: true});
    target.scrollIntoView({block: 'nearest', behavior: 'smooth'});
  };
  const validate = async form => {
    if (config.loginRequired && !config.loggedIn) {
      location.assign(config.loginUrl);
      return false;
    }
    try {
      const response = await fetch(config.cartUrl + '.js', {cache: 'no-store', credentials: 'same-origin', headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Cart check failed');
      const cart = await response.json();
      if (cart.item_count < config.minimum) {
        showError(config.minimumMessage.replaceAll('__MIN__', config.minimum).replaceAll('__REMAINING__', config.minimum - cart.item_count).replaceAll('__COUNT__', cart.item_count), form);
        return false;
      }
      return true;
    } catch {
      showError(config.retryMessage, form);
      return false;
    }
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (approvedForms.has(form)) { approvedForms.delete(form); return; }
    const button = event.submitter;
    if (button?.name !== 'checkout' && !isCheckout(form.action) && !isCheckout(button?.formAction)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    try {
      if (await validate(form)) {
        approvedForms.add(form);
        form.requestSubmit(button instanceof HTMLElement ? button : undefined);
      }
    } finally { pending = false; }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !isCheckout(link.href) || event.defaultPrevented) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    try { if (await validate()) location.assign(link.href); }
    finally { pending = false; }
  }, true);
})();
